import styled, { css } from 'vue-styled-components';

import { ActionButton as _ActionButton } from '@components/Common/Dialog';
import DescendingIcon from '@svgIcons/dashboard/descending.svg';
import WithDropdown from '@/components/Common/WithDropdown';

import { BLUE } from '@styles/common.styled';

export default {
    name: 'DropdownButton',
    props: {
        options: {
            type: Array,
            default() {},
        },
        text: String,
        cb: {
            type: Function,
            default: R.identity,
        },
        placement: String,
        getPopupContainer: Function,
        confirmDisabled: Boolean,
        confirmOnlyDisabled: Boolean,
        dropdownDisabled: Boolean,
    },
    functional: true,
    render(h, { props }) {
        const {
            options,
            cb,
            text,
            placement,
            getPopupContainer,
            confirmDisabled,
            confirmOnlyDisabled,
        } = props;

        return (
            <ApplyButton
                disabled={confirmDisabled}
                confirmOnlyDisabled={confirmOnlyDisabled}
            >
                <div class="text-area" onClick={cb}>
                    {text}
                </div>
                <WithDropdown
                    trigger={
                        <div class="dropdown-area">
                            <DescendingIcon v-view-box />
                        </div>
                    }
                    options={options}
                    placement={placement}
                    getPopupContainer={getPopupContainer}
                />
            </ApplyButton>
        );
    },
};

const _BLUE_60 = BLUE(60);

const ApplyButton = styled(_ActionButton, {
    disabled: Boolean,
    confirmOnlyDisabled: Boolean,
})`
    padding: 0;
    &:hover {
        background-color: ${({ disabled }) => (disabled ? BLUE(30) : _BLUE_60)};
    }

    & > div {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${_BLUE_60};
        transition: background-color 0.2s;
        cursor: pointer;

        ${({ disabled }) =>
            disabled &&
            css`
                background-color: ${BLUE(30)};
                cursor: unset;
                &:hover {
                    background-color: ${BLUE(30)};
                }
            `}
    }
    .text-area {
        border-right: 1px solid white;
        font-size: 14px;
        font-weight: 600;

        ${({ confirmOnlyDisabled }) =>
            confirmOnlyDisabled &&
            css`
                background-color: ${BLUE(30)};
                cursor: not-allowed;
                &:hover {
                    background-color: ${BLUE(30)};
                }
            `}
    }
    .dropdown-area {
        height: 100%;
    }
    button {
        padding: 0;
    }
    svg {
        width: 16px;
        height: 16px;
        fill: white;
    }
`;
